module.exports = __webpack_public_path__ + "static/media/PoppinsMedium.5289ff95.ttf";